/* ============
 * Locale
 * ============
 *
 * For a multilanguage application, you can
 * specify the languages you want to use here.
 */

import phrase from './fr.json';
import en from './en.json';

export default {
  fr: phrase,
  en,
};
